import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    input: {
      flex: 1,
      marginTop: theme.spacing(10),
      maxWidth: 373,
      width: "100%",
      [theme.breakpoints.up("md")]: {
        marginLeft: theme.spacing(10),
        marginTop: theme.spacing(0),
        maxWidth: "383px !important",
        width: "auto",
      },
    },
    TooltipWrapper: {
      alignItems: "center",
      display: "flex",
      flexWrap: "wrap",
      width: "100%",
      "&+&": {
        paddingTop: theme.spacing(12),
      },
    },
    NextTooltipWrapper: { marginRight: -30 },
    addTranslation: {
      alignSelf: "start",
      color: theme.gray500,
      height: theme.spacing(28),
      padding: theme.spacing(6),
    },
    selectWrapper: {
      flex: 1,
      maxWidth: 373,
      width: "100%",
      "& + &": { marginTop: theme.spacing(10) },
    },
    error: {
      color: theme.red500,
      display: "block",
      fontSize: 14,
      marginBottom: theme.spacing(8),
      "& + &": {
        marginTop: 0,
      },
    },
    translationSection: {
      maxWidth: "100%",
      position: "relative",
      "&+&": {
        paddingTop: theme.spacing(12),
      },
      "&+&::after": {
        content: '""',
        left: 0,
        position: "absolute",
        top: 0,
        width: "100%",
      },
    },
    buttonSection: {
      color: theme.primary500,
      background: theme.white50,
      margin: theme.spacing(12),
    },
    conditionWrapper: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
    },
    header: {
      color: theme.gray800,
      fontSize: 18,
      marginBottom: theme.spacing(4),
    },
    fullWidth: { width: "100% !important", maxWidth: "100% !important" },
    horizontalLine: {
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontSize: 14,
      textTransform: "uppercase",
      margin: "0 24px",
      flex: 0,
      maxWidth: "calc(100% - 48px)",
      "&::after": {
        content: "''",
        background: theme.gray200,
        display: "block",
        height: "1px",
        minWidth: "50%",
        flex: "1",
        marginLeft: "5px",
      },
      "&::before": {
        content: "''",
        background: theme.gray200,
        display: "block",
        height: "1px",
        minWidth: "50px",
        marginRight: "5px",
      },
    },
    condition: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      flex: 1,
      gap: theme.spacing(10),
    },
    conditionSection: {
      alignItems: "center",
      display: "flex",
      maxWidth: "100%",
      padding: theme.spacing(12, 12, 16, 12),
      position: "relative",
    },
    wallet: {
      backgroundColor: theme.white50,
    },
    clearIcon: {
      alignSelf: "start",
      marginLeft: "16px",
    },
    resetMargin: {
      margin: 0,
    },
    achievementConditionPadding: {
      padding: theme.spacing(0, 0, 16),
    },
    buttonWrapper: {
      display: "flex",
      justifyContent: "flex-start",
    },
    flexEnd: {
      justifyContent: "flex-end",
    },
    rulesWrapper: {
      marginBottom: theme.spacing(12),
    },
    rule: {
      marginBottom: theme.spacing(12),
    },
    generalError: {
      fontSise: "14px",
      marginBottom: theme.spacing(8),
      fontWeight: 500,
      color: theme.red500,
    },
    displayNone: {
      display: "none",
      "&.error-edit-display": {
        display: "block",
      },
    },
    campaignVisibilityInfo: {
      fontSize: "12px",
      color: theme.gray500,
      marginTop: theme.spacing(6),
    },
    link: {
      fontSize: 14,
      color: theme.gray500,
      "& a": {
        fontSize: 14,
      },
    },
    days: {
      display: "flex",
      gap: theme.spacing(7),
      marginTop: theme.spacing(6),
    },
    day: {
      width: "48px",
      height: "48px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: theme.spacing(6, 2.5),
      border: `1px solid ${theme.gray200}`,
      borderRadius: "24px",
      fontSize: "14px",
      lineHeight: "20px",
      color: theme.black,
      cursor: "pointer",
    },
    selectedDay: {
      backgroundColor: theme.primary500,
      color: theme.primary50,
    },
    disabledDay: {
      opacity: 0.32,
      cursor: "default",
    },
    tooltipTitle: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "24px",
      color: theme.gray800,
    },
    tooltipDesc: {
      whiteSpace: "break-spaces",
      marginTop: theme.spacing(2),
      fontSize: "12px",
      lineHeight: "20px",
      fontWeight: 400,
    },
    tooltipButton: {
      fontSize: "12px",
      fontWeight: 500,
      color: theme.primary500,
      textTransform: "none",
      textDecoration: "underline",
      padding: 0,
      marginTop: theme.spacing(6),
    },
    disabledCampaignInfoWrapper: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(2),
      margin: theme.spacing(-2, 0, 4),
    },
    lockIcon: {
      width: "16px",
      height: "16px",
      color: theme.orange600,
      "& path": {
        color: theme.orange600,
        stroke: theme.orange600,
        strokeWidth: "1.5px",
      },
    },
    limitTitle: {
      color: theme.gray800,
      fontWeight: 500,
      fontSize: 14,
    },
  }),
);
